import * as _ from 'lodash';
import DropdownSelector from '../DropdownSelector';

export class AisleManagement extends DropdownSelector {
  /**
   * Override method
   */
  handleClickOutsideOfComponent = e => {
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    this.setState({
      opened: false,
    });
    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  /**
   * Override method
   */
  handleOpen = e => {
    e.preventDefault();
    if (!this.state.opened) {
      if (this.tippyRef && this.tippyRef.current !== null) {
        this.tippyRef.current.hide(0);
      }
      if (this.state.reloadOptions) {
        this.setState(
          prevState => ({
            temporarySelected: prevState.selected,
            temporarySelectAll: prevState.selectAll,
            opened: true,
            loaded: false,
            isLoading: true,
            options: [],
          }),
          () => {
            this.loadData();
          }
        );
      } else {
        this.setState(prevState => ({
          temporarySelected: prevState.selected,
          temporarySelectAll: prevState.selectAll,
          opened: true,
        }));
      }
    } else {
      this.resetSelected();
    }
    if (this.state.opened && _.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/AisleManagement.jsx